// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_home.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { ProposalPursuitLink } from "./proposal_record_pb";
/**
 * @generated from message mono.projectdata.v1.GetProposalHomeRequest
 */ export class GetProposalHomeRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalHomeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalHomeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalHomeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalHomeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalHomeRequest, "runtime", proto3);
_define_property(GetProposalHomeRequest, "typeName", "mono.projectdata.v1.GetProposalHomeRequest");
_define_property(GetProposalHomeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * No separate totals: each count is the length of its complete authorized list.
 *
 * @generated from message mono.projectdata.v1.ProposalHomeItem
 */ export class ProposalHomeItem extends Message {
    static fromBinary(bytes, options) {
        return new ProposalHomeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalHomeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalHomeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalHomeItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string href = 3;
   */ _define_property(this, "href", ""), /**
   * @generated from field: string explanation = 4;
   */ _define_property(this, "explanation", ""), /**
   * @generated from field: string date = 5;
   */ _define_property(this, "date", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalHomeItem, "runtime", proto3);
_define_property(ProposalHomeItem, "typeName", "mono.projectdata.v1.ProposalHomeItem");
_define_property(ProposalHomeItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "explanation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetProposalHomeResponse
 */ export class GetProposalHomeResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProposalHomeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProposalHomeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProposalHomeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProposalHomeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string as_of = 2;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: bool has_compliance_basis = 3;
   */ _define_property(this, "hasComplianceBasis", false), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalHomeItem open_requirements = 4;
   */ _define_property(this, "openRequirements", []), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalHomeItem changed_amendments = 5;
   */ _define_property(this, "changedAmendments", []), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalHomeItem pending_reviews = 6;
   */ _define_property(this, "pendingReviews", []), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalHomeItem deadlines = 7;
   */ _define_property(this, "deadlines", []), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalHomeItem assignments = 8;
   */ _define_property(this, "assignments", []), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalHomeItem volumes = 9;
   */ _define_property(this, "volumes", []), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalHomeItem strategy = 10;
   */ _define_property(this, "strategy", []), /**
   * PRP-05 (fields 11-21).
   *
   * @generated from field: mono.projectdata.v1.ProposalHomeHeader header = 11;
   */ _define_property(this, "header", void 0), /**
   * @generated from field: mono.projectdata.v1.ProposalComplianceKpi compliance = 12;
   */ _define_property(this, "compliance", void 0), /**
   * @generated from field: mono.projectdata.v1.ProposalDraftingKpi drafting = 13;
   */ _define_property(this, "drafting", void 0), /**
   * @generated from field: mono.projectdata.v1.ProposalPriceKpi price = 14;
   */ _define_property(this, "price", void 0), /**
   * @generated from field: mono.projectdata.v1.ProposalNextReview next_review = 15;
   */ _define_property(this, "nextReview", void 0), /**
   * summary rows (no items); empty when no pursuit or denied
   *
   * @generated from field: repeated mono.projectdata.v1.CarriedInRow carried_in = 16;
   */ _define_property(this, "carriedIn", []), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalHomeItem pass_fail_open = 17;
   */ _define_property(this, "passFailOpen", []), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalBriefingFact briefing = 18;
   */ _define_property(this, "briefing", []), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalHomeMilestone milestones = 19;
   */ _define_property(this, "milestones", []), /**
   * @generated from field: mono.projectdata.v1.ProposalHomePursuit pursuit = 20;
   */ _define_property(this, "pursuit", void 0), /**
   * @generated from field: mono.projectdata.v1.ProposalHomeCapabilities capabilities = 21;
   */ _define_property(this, "capabilities", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProposalHomeResponse, "runtime", proto3);
_define_property(GetProposalHomeResponse, "typeName", "mono.projectdata.v1.GetProposalHomeResponse");
_define_property(GetProposalHomeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "has_compliance_basis",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "open_requirements",
            kind: "message",
            T: ProposalHomeItem,
            repeated: true
        },
        {
            no: 5,
            name: "changed_amendments",
            kind: "message",
            T: ProposalHomeItem,
            repeated: true
        },
        {
            no: 6,
            name: "pending_reviews",
            kind: "message",
            T: ProposalHomeItem,
            repeated: true
        },
        {
            no: 7,
            name: "deadlines",
            kind: "message",
            T: ProposalHomeItem,
            repeated: true
        },
        {
            no: 8,
            name: "assignments",
            kind: "message",
            T: ProposalHomeItem,
            repeated: true
        },
        {
            no: 9,
            name: "volumes",
            kind: "message",
            T: ProposalHomeItem,
            repeated: true
        },
        {
            no: 10,
            name: "strategy",
            kind: "message",
            T: ProposalHomeItem,
            repeated: true
        },
        {
            no: 11,
            name: "header",
            kind: "message",
            T: ProposalHomeHeader
        },
        {
            no: 12,
            name: "compliance",
            kind: "message",
            T: ProposalComplianceKpi
        },
        {
            no: 13,
            name: "drafting",
            kind: "message",
            T: ProposalDraftingKpi
        },
        {
            no: 14,
            name: "price",
            kind: "message",
            T: ProposalPriceKpi
        },
        {
            no: 15,
            name: "next_review",
            kind: "message",
            T: ProposalNextReview
        },
        {
            no: 16,
            name: "carried_in",
            kind: "message",
            T: CarriedInRow,
            repeated: true
        },
        {
            no: 17,
            name: "pass_fail_open",
            kind: "message",
            T: ProposalHomeItem,
            repeated: true
        },
        {
            no: 18,
            name: "briefing",
            kind: "message",
            T: ProposalBriefingFact,
            repeated: true
        },
        {
            no: 19,
            name: "milestones",
            kind: "message",
            T: ProposalHomeMilestone,
            repeated: true
        },
        {
            no: 20,
            name: "pursuit",
            kind: "message",
            T: ProposalHomePursuit
        },
        {
            no: 21,
            name: "capabilities",
            kind: "message",
            T: ProposalHomeCapabilities
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalHomeHeader
 */ export class ProposalHomeHeader extends Message {
    static fromBinary(bytes, options) {
        return new ProposalHomeHeader().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalHomeHeader().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalHomeHeader().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalHomeHeader, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string solicitation_number = 1;
   */ _define_property(this, "solicitationNumber", ""), /**
   * RFC3339 UTC
   *
   * @generated from field: string due_at = 2;
   */ _define_property(this, "dueAt", ""), /**
   * IANA or ""
   *
   * @generated from field: string due_timezone = 3;
   */ _define_property(this, "dueTimezone", ""), /**
   * @generated from field: int32 volume_count = 4;
   */ _define_property(this, "volumeCount", 0), /**
   * outline sections with volume_id != ""
   *
   * @generated from field: int32 section_count = 5;
   */ _define_property(this, "sectionCount", 0), /**
   * e.g. "Pink team"
   *
   * @generated from field: string next_milestone_label = 6;
   */ _define_property(this, "nextMilestoneLabel", ""), /**
   * RFC3339
   *
   * @generated from field: string next_milestone_at = 7;
   */ _define_property(this, "nextMilestoneAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalHomeHeader, "runtime", proto3);
_define_property(ProposalHomeHeader, "typeName", "mono.projectdata.v1.ProposalHomeHeader");
_define_property(ProposalHomeHeader, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "due_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "due_timezone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "volume_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "section_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "next_milestone_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "next_milestone_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalComplianceKpi
 */ export class ProposalComplianceKpi extends Message {
    static fromBinary(bytes, options) {
        return new ProposalComplianceKpi().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalComplianceKpi().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalComplianceKpi().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalComplianceKpi, a, b);
    }
    constructor(data){
        super(), /**
   * coverage has a current version
   *
   * @generated from field: bool has_basis = 1;
   */ _define_property(this, "hasBasis", false), /**
   * @generated from field: int32 total = 2;
   */ _define_property(this, "total", 0), /**
   * @generated from field: int32 addressed = 3;
   */ _define_property(this, "addressed", 0), /**
   * @generated from field: int32 partial = 4;
   */ _define_property(this, "partial", 0), /**
   * @generated from field: int32 unaddressed = 5;
   */ _define_property(this, "unaddressed", 0), /**
   * pass/fail requirements not addressed
   *
   * @generated from field: int32 pass_fail_open = 6;
   */ _define_property(this, "passFailOpen", 0), /**
   * an evaluation scheme with gate factors exists
   *
   * @generated from field: bool pass_fail_basis = 7;
   */ _define_property(this, "passFailBasis", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalComplianceKpi, "runtime", proto3);
_define_property(ProposalComplianceKpi, "typeName", "mono.projectdata.v1.ProposalComplianceKpi");
_define_property(ProposalComplianceKpi, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "has_basis",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "addressed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "partial",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "unaddressed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "pass_fail_open",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "pass_fail_basis",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalDraftingKpi
 */ export class ProposalDraftingKpi extends Message {
    static fromBinary(bytes, options) {
        return new ProposalDraftingKpi().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalDraftingKpi().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalDraftingKpi().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalDraftingKpi, a, b);
    }
    constructor(data){
        super(), /**
   * outline sections with volume_id != ""
   *
   * @generated from field: int32 sections = 1;
   */ _define_property(this, "sections", 0), /**
   * body_chars > 0 (ONLYOFFICE outline measure)
   *
   * @generated from field: int32 drafted = 2;
   */ _define_property(this, "drafted", 0), /**
   * sections - drafted
   *
   * @generated from field: int32 no_first_draft = 3;
   */ _define_property(this, "noFirstDraft", 0), /**
   * sections whose volume has no ONLYOFFICE document
   *
   * @generated from field: int32 without_document = 4;
   */ _define_property(this, "withoutDocument", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalDraftingKpi, "runtime", proto3);
_define_property(ProposalDraftingKpi, "typeName", "mono.projectdata.v1.ProposalDraftingKpi");
_define_property(ProposalDraftingKpi, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sections",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "drafted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "no_first_draft",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "without_document",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalBlackHatRange
 */ export class ProposalBlackHatRange extends Message {
    static fromBinary(bytes, options) {
        return new ProposalBlackHatRange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalBlackHatRange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalBlackHatRange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalBlackHatRange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string participant_id = 2;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string company_name = 4;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: int64 low_cents = 5;
   */ _define_property(this, "lowCents", protoInt64.zero), /**
   * @generated from field: int64 high_cents = 6;
   */ _define_property(this, "highCents", protoInt64.zero), /**
   * @generated from field: int32 assessment_version = 7;
   */ _define_property(this, "assessmentVersion", 0), /**
   * RFC3339
   *
   * @generated from field: string assessed_at = 8;
   */ _define_property(this, "assessedAt", ""), /**
   * "/capture/{id}/black-hat"
   *
   * @generated from field: string href = 9;
   */ _define_property(this, "href", ""), /**
   * below | inside | above | unknown (our total vs [low, high])
   *
   * @generated from field: string position = 10;
   */ _define_property(this, "position", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalBlackHatRange, "runtime", proto3);
_define_property(ProposalBlackHatRange, "typeName", "mono.projectdata.v1.ProposalBlackHatRange");
_define_property(ProposalBlackHatRange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "low_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "high_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 7,
            name: "assessment_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "assessed_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "position",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalPriceKpi
 */ export class ProposalPriceKpi extends Message {
    static fromBinary(bytes, options) {
        return new ProposalPriceKpi().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalPriceKpi().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalPriceKpi().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalPriceKpi, a, b);
    }
    constructor(data){
        super(), /**
   * live server engine total of the primary scenario head
   *
   * @generated from field: optional int64 our_total_cents = 1;
   */ _define_property(this, "ourTotalCents", void 0), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", ""), /**
   * one per competitor with a COMPLETE range; primary first
   *
   * @generated from field: repeated mono.projectdata.v1.ProposalBlackHatRange black_hat = 3;
   */ _define_property(this, "blackHat", []), /**
   * @generated from field: string computed_at = 4;
   */ _define_property(this, "computedAt", ""), /**
   * "pricingengine-go-v1"
   *
   * @generated from field: string calc_version = 5;
   */ _define_property(this, "calcVersion", ""), /**
   * 0 when never frozen
   *
   * @generated from field: int32 latest_frozen_version_no = 6;
   */ _define_property(this, "latestFrozenVersionNo", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalPriceKpi, "runtime", proto3);
_define_property(ProposalPriceKpi, "typeName", "mono.projectdata.v1.ProposalPriceKpi");
_define_property(ProposalPriceKpi, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "our_total_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "black_hat",
            kind: "message",
            T: ProposalBlackHatRange,
            repeated: true
        },
        {
            no: 4,
            name: "computed_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "calc_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "latest_frozen_version_no",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalNextReview
 */ export class ProposalNextReview extends Message {
    static fromBinary(bytes, options) {
        return new ProposalNextReview().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalNextReview().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalNextReview().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalNextReview, a, b);
    }
    constructor(data){
        super(), /**
   * YYYY-MM-DD
   *
   * @generated from field: string date = 1;
   */ _define_property(this, "date", ""), /**
   * review name or milestone label ("Pink team")
   *
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * only when from a review session
   *
   * @generated from field: int32 reviewer_count = 3;
   */ _define_property(this, "reviewerCount", 0), /**
   * @generated from field: string review_id = 4;
   */ _define_property(this, "reviewId", ""), /**
   * @generated from field: string milestone_id = 5;
   */ _define_property(this, "milestoneId", ""), /**
   * @generated from field: string href = 6;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalNextReview, "runtime", proto3);
_define_property(ProposalNextReview, "typeName", "mono.projectdata.v1.ProposalNextReview");
_define_property(ProposalNextReview, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reviewer_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "milestone_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalBriefingFact
 */ export class ProposalBriefingFact extends Message {
    static fromBinary(bytes, options) {
        return new ProposalBriefingFact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalBriefingFact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalBriefingFact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalBriefingFact, a, b);
    }
    constructor(data){
        super(), /**
   * solicitation | agency | office | vehicle | contract_type | set_aside | naics
   *
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * "Solicitation"
   *
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * display value ("Full and open" for unrestricted)
   *
   * @generated from field: string value = 3;
   */ _define_property(this, "value", ""), /**
   * registry link when an id exists, else ""
   *
   * @generated from field: string href = 4;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalBriefingFact, "runtime", proto3);
_define_property(ProposalBriefingFact, "typeName", "mono.projectdata.v1.ProposalBriefingFact");
_define_property(ProposalBriefingFact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalHomeMilestone
 */ export class ProposalHomeMilestone extends Message {
    static fromBinary(bytes, options) {
        return new ProposalHomeMilestone().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalHomeMilestone().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalHomeMilestone().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalHomeMilestone, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string milestone_type = 3;
   */ _define_property(this, "milestoneType", ""), /**
   * RFC3339
   *
   * @generated from field: string scheduled_at = 4;
   */ _define_property(this, "scheduledAt", ""), /**
   * RFC3339 or ""
   *
   * @generated from field: string completed_at = 5;
   */ _define_property(this, "completedAt", ""), /**
   * "sent" | "done" | ""
   *
   * @generated from field: string state_label = 6;
   */ _define_property(this, "stateLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalHomeMilestone, "runtime", proto3);
_define_property(ProposalHomeMilestone, "typeName", "mono.projectdata.v1.ProposalHomeMilestone");
_define_property(ProposalHomeMilestone, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "milestone_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scheduled_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "completed_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "state_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalHomePursuit
 */ export class ProposalHomePursuit extends Message {
    static fromBinary(bytes, options) {
        return new ProposalHomePursuit().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalHomePursuit().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalHomePursuit().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalHomePursuit, a, b);
    }
    constructor(data){
        super(), /**
   * nil when none or the caller cannot read it
   *
   * @generated from field: mono.projectdata.v1.ProposalPursuitLink link = 1;
   */ _define_property(this, "link", void 0), /**
   * go | no_go | defer
   *
   * @generated from field: string latest_decision_outcome = 2;
   */ _define_property(this, "latestDecisionOutcome", ""), /**
   * RFC3339
   *
   * @generated from field: string latest_decision_at = 3;
   */ _define_property(this, "latestDecisionAt", ""), /**
   * gate label ("Gate 3") or "Go/no-go decision"
   *
   * @generated from field: string latest_decision_label = 4;
   */ _define_property(this, "latestDecisionLabel", ""), /**
   * @generated from field: string incumbent_company_profile_id = 5;
   */ _define_property(this, "incumbentCompanyProfileId", ""), /**
   * @generated from field: string incumbent_name = 6;
   */ _define_property(this, "incumbentName", ""), /**
   * @generated from field: bool incumbent_is_us = 7;
   */ _define_property(this, "incumbentIsUs", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalHomePursuit, "runtime", proto3);
_define_property(ProposalHomePursuit, "typeName", "mono.projectdata.v1.ProposalHomePursuit");
_define_property(ProposalHomePursuit, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: ProposalPursuitLink
        },
        {
            no: 2,
            name: "latest_decision_outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "latest_decision_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "latest_decision_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "incumbent_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "incumbent_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "incumbent_is_us",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposalHomeCapabilities
 */ export class ProposalHomeCapabilities extends Message {
    static fromBinary(bytes, options) {
        return new ProposalHomeCapabilities().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposalHomeCapabilities().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposalHomeCapabilities().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposalHomeCapabilities, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool can_edit_proposal = 1;
   */ _define_property(this, "canEditProposal", false), /**
   * @generated from field: bool can_start_review = 2;
   */ _define_property(this, "canStartReview", false), /**
   * @generated from field: bool can_read_pricing = 3;
   */ _define_property(this, "canReadPricing", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposalHomeCapabilities, "runtime", proto3);
_define_property(ProposalHomeCapabilities, "typeName", "mono.projectdata.v1.ProposalHomeCapabilities");
_define_property(ProposalHomeCapabilities, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "can_edit_proposal",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "can_start_review",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "can_read_pricing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * PRP-04: what a proposal inherited from its pursuit.
 * Not ProposalPursuitLink (proposal_record.proto, PRP-01): that file is not on main.
 *
 * @generated from message mono.projectdata.v1.CarriedInPursuit
 */ export class CarriedInPursuit extends Message {
    static fromBinary(bytes, options) {
        return new CarriedInPursuit().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CarriedInPursuit().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CarriedInPursuit().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CarriedInPursuit, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string href = 3;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CarriedInPursuit, "runtime", proto3);
_define_property(CarriedInPursuit, "typeName", "mono.projectdata.v1.CarriedInPursuit");
_define_property(CarriedInPursuit, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CarriedInItem
 */ export class CarriedInItem extends Message {
    static fromBinary(bytes, options) {
        return new CarriedInItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CarriedInItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CarriedInItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CarriedInItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string source_version_id = 3;
   */ _define_property(this, "sourceVersionId", ""), /**
   * @generated from field: string href = 4;
   */ _define_property(this, "href", ""), /**
   * @generated from field: repeated string lands_section_ids = 5;
   */ _define_property(this, "landsSectionIds", []), /**
   * mapped | not_mapped | reused | drafted | needs_decision | internal_only
   *
   * @generated from field: string state = 6;
   */ _define_property(this, "state", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CarriedInItem, "runtime", proto3);
_define_property(CarriedInItem, "typeName", "mono.projectdata.v1.CarriedInItem");
_define_property(CarriedInItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "lands_section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CarriedInRow
 */ export class CarriedInRow extends Message {
    static fromBinary(bytes, options) {
        return new CarriedInRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CarriedInRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CarriedInRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CarriedInRow, a, b);
    }
    constructor(data){
        super(), /**
   * hot_buttons | win_themes | rfi_answers | past_performance | black_hat | labor_categories
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * items of this kind visible to the caller
   *
   * @generated from field: int32 count = 3;
   */ _define_property(this, "count", 0), /**
   * up to 3 item titles joined with " · "
   *
   * @generated from field: string summary = 4;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: string from_label = 5;
   */ _define_property(this, "fromLabel", ""), /**
   * @generated from field: string from_href = 6;
   */ _define_property(this, "fromHref", ""), /**
   * @generated from field: string lands_label = 7;
   */ _define_property(this, "landsLabel", ""), /**
   * @generated from field: repeated string lands_section_ids = 8;
   */ _define_property(this, "landsSectionIds", []), /**
   * @generated from field: string lands_href = 9;
   */ _define_property(this, "landsHref", ""), /**
   * mapped | partially_mapped | not_mapped | reused | drafted | needs_decision | hearsay_not_citable
   *
   * @generated from field: string status = 10;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string status_label = 11;
   */ _define_property(this, "statusLabel", ""), /**
   * citable | internal_only
   *
   * @generated from field: string citability = 12;
   */ _define_property(this, "citability", ""), /**
   * only when include_items
   *
   * @generated from field: repeated mono.projectdata.v1.CarriedInItem items = 13;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CarriedInRow, "runtime", proto3);
_define_property(CarriedInRow, "typeName", "mono.projectdata.v1.CarriedInRow");
_define_property(CarriedInRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "from_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "from_href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "lands_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "lands_section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "lands_href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "status_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "citability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "items",
            kind: "message",
            T: CarriedInItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalCarriedInRequest
 */ export class ListProposalCarriedInRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalCarriedInRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalCarriedInRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalCarriedInRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalCarriedInRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: bool include_items = 2;
   */ _define_property(this, "includeItems", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalCarriedInRequest, "runtime", proto3);
_define_property(ListProposalCarriedInRequest, "typeName", "mono.projectdata.v1.ListProposalCarriedInRequest");
_define_property(ListProposalCarriedInRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_items",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListProposalCarriedInResponse
 */ export class ListProposalCarriedInResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProposalCarriedInResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProposalCarriedInResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProposalCarriedInResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProposalCarriedInResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * unset for a direct proposal or a hidden pursuit
   *
   * @generated from field: mono.projectdata.v1.CarriedInPursuit pursuit = 2;
   */ _define_property(this, "pursuit", void 0), /**
   * fixed order: hot_buttons, win_themes, rfi_answers, past_performance, black_hat, labor_categories
   *
   * @generated from field: repeated mono.projectdata.v1.CarriedInRow rows = 3;
   */ _define_property(this, "rows", []), /**
   * caller can read but not adopt (Pricing-only, view_only member)
   *
   * @generated from field: bool read_only = 4;
   */ _define_property(this, "readOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProposalCarriedInResponse, "runtime", proto3);
_define_property(ListProposalCarriedInResponse, "typeName", "mono.projectdata.v1.ListProposalCarriedInResponse");
_define_property(ListProposalCarriedInResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pursuit",
            kind: "message",
            T: CarriedInPursuit
        },
        {
            no: 3,
            name: "rows",
            kind: "message",
            T: CarriedInRow,
            repeated: true
        },
        {
            no: 4,
            name: "read_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
